import classNames from 'classnames'
import _ from 'lodash'

const CSS_PREFIX = 's-finance'

export const r2px = (value, point = 14) => (_.isNumber(value) ? `${value * point}px` : value)

export const applyClassName = (className, internalClassName = '') => classNames(internalClassName, `${CSS_PREFIX}-${className}`)
